import { render, staticRenderFns } from "./EmailValidation.vue?vue&type=template&id=a34a1454&scoped=true"
import script from "./EmailValidation.vue?vue&type=script&lang=js"
export * from "./EmailValidation.vue?vue&type=script&lang=js"
import style0 from "./EmailValidation.vue?vue&type=style&index=0&id=a34a1454&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a34a1454",
  null
  
)

export default component.exports